import ApiService from '@/lib/ApiService'

const apiService = {
	install: (vue: any): any => {
		vue.prototype.$apiService = new ApiService()
	}
}
export default apiService
